import script from "./CTASection.vue?vue&type=script&setup=true&lang=js"
export * from "./CTASection.vue?vue&type=script&setup=true&lang=js"

import "./CTASection.vue?vue&type=style&index=0&id=3973610b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3973610b"]])

export default __exports__